import { render, staticRenderFns } from "./PostContent.vue?vue&type=template&id=c6a2a402&"
import script from "./PostContent.vue?vue&type=script&lang=js&"
export * from "./PostContent.vue?vue&type=script&lang=js&"
import style0 from "./PostContent.vue?vue&type=style&index=0&id=c6a2a402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports